
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { HomePage } from "@/pages/HomePage";
import { TimerPage } from "@/pages/TimerPage";
import { LearnPage } from "@/pages/LearnPage";
import { ProgressPage } from "@/pages/ProgressPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { FastingProvider } from "@/contexts/FastingContext";
import { FastingHistoryProvider } from "@/contexts/fasting/FastingHistoryContext";
import NotFound from "@/pages/NotFound";
import { RefeedingPage } from "@/pages/RefeedingPage";
import { CookieConsent } from "@/components/CookieConsent";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <FastingHistoryProvider>
        <FastingProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route element={<AppLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/timer" element={<TimerPage />} />
                <Route path="/learn" element={<LearnPage />} />
                <Route path="/progress" element={<ProgressPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/refeeding" element={<RefeedingPage />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <CookieConsent />
        </FastingProvider>
      </FastingHistoryProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
